define('common/ko/fn/decode',['knockout', 'jquery'], function(ko, $) {

    /**
     * Use this to decode html entities on trusted data sources.
     */
    ko.subscribable.fn.decode = function() {
        var self = this;

        return ko.pureComputed(function () {
            return $('<div/>').html( self() ).text();
        });
    };

});

